import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ProblemForUserFacade } from 'src/app/store/problem-user/facade';
import { ProblemForUserModel } from 'src/app/store/problem-user/model';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { getTimeLeft, ProblemModel } from 'src/app/store/problem/model';
import { UserFacade } from 'src/app/store/user/facade';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class DashboardComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private problemForUserFacade = inject(ProblemForUserFacade);
  private problemFacade = inject(ProblemFacade);
  private userFacade = inject(UserFacade);
  private titleService = inject(Title);

  problems: ProblemForUserModel[] = [];

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MESSAGES_PAGE').subscribe(page => {
      this.translate.get('TITLE_MAIN').subscribe(main => {
        this.titleService.setTitle(page + ' ' + main);
      });
    });

    this.problemForUserFacade.allProblems$.subscribe(problems => {
      if (this.problems.length > 0) {
        problems.forEach(newProblem => {
          let curProblem = this.problems.find(x => {
            return x.id === newProblem.id;
          });
          if (curProblem) {
            curProblem.lockId = newProblem.lockId;
            curProblem.subscriptionId = newProblem.subscriptionId;
          }
        });
      } else {
        if (problems.length > 0) {
          this.problems = [];
          problems.forEach(x => {
            this.problems.push({ ...x });
          });
        } else {
          this.goToSelfDiagnosticPage();
        }
      }
    });
  }

  subscribeToProblem(event, problemId: number) {
    event.event.preventDefault();
    event.event.stopPropagation();

    this.userFacade.selected().subscribe(user => {
      this.problemForUserFacade.subscriptionProblem(problemId, user.id);
    });
  }

  unSubscribeToProblem(event, subscriptionId: number) {
    event.event.preventDefault();
    event.event.stopPropagation();

    this.problemForUserFacade.unSubscriptionProblem(subscriptionId);
  }

  getTimeLeft(problem: ProblemModel) {
    return getTimeLeft(problem);
  }

  onItemTitleClick($event) {
    if (!$event.itemData.lockId) {
      this.userFacade.selected().subscribe(user => {
        this.problemForUserFacade.lockProblem($event.itemData.id, user.id);
      });
    }
  }

  convertImage(problem: ProblemModel): any {
    return this.problemFacade.convertImage(problem);
  }

  goToSelfDiagnosticPage() {
    this.router.navigate(['/self-diagnostic']);
  }
}
